import React from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import UserAccountDetails from "../components/Profile";

const AdminProfile = () => (
  <Container fluid className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle
        title="Admin Profile"
        subtitle=""
        md="12"
        className="ml-sm-auto mr-sm-auto"
      />
    </Row>
    <Row>
      <Col lg="12">
        <UserAccountDetails />
      </Col>
    </Row>
  </Container>
);

export default AdminProfile;
